import script from "./SocialIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialIcons.vue?vue&type=script&setup=true&lang=js"

import "./SocialIcons.vue?vue&type=style&index=0&id=e16b4ecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16b4ecc"]])

export default __exports__